webpackJsonp([112],{

/***/ "4k6L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CheckIp; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_env_js__ = __webpack_require__("AMf1");



var CheckIp = function CheckIp(Path) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__config_env_js__["a" /* apiUrl */] + '/access', {
    'path': Path
  });
};

/***/ }),

/***/ "9DFf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_ja__ = __webpack_require__("7Ppv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_ja___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_ja__);




/*
// ここでメッセージ
const dictionary = {
  ja: {
    messages: {
      required: (field) => '' + field
    },
    attributes: {
      sponsorName: '',
      advert: '',
      phone: '',
      companyName: '',
      id: ''
    }
  }
}

// dddd
Validator.extend('advert', {
  messages: {
    ja: field => 'ID请输入选手6位ID号'
  },
  validate: value => {
    // if (getLength(value) > 8) {
    //   return value = limitMaxLength(value, 8)
    // }
  }
})
*/
// ここで上のやつもろもろ設定
// Validator.updateDictionary(dictionary)

// VeeValidate.Validator.addLocale(VeeValidateJaLocale)

__WEBPACK_IMPORTED_MODULE_1_vee_validate__["a" /* default */].Validator.localize('ja', __WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_ja___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["a" /* default */], { locale: 'ja' });

/***/ }),

/***/ "9KKl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return appWhitelist; });
var appWhitelist = [['setToken'], ['logout'], ['profile'], ['interviewRecord'], ['search'], ['advanceConfirmAnswer'], ['publicRecruitmentRecord'], ['publicRecruitment'], ['publicRecruitmentApplication'], ['publicRecruitmentAdvanceConfirmAnswer'], ['resultManagementSearch'], ['resultManagementDetail'], ['resultManagementRecord'], ['transferHopeRegister'], ['transferHopeRecord'], ['transferHopeSearch'], ['transferHopeDetail'], ['minutesRegister'], ['minutesSearch'], ['minutesDetail'], ['minutesEdit'], ['minutesAgendaRegister'], ['minutesAgendaDetail'], ['leaveOfAbsence', 'register']];

/***/ }),

/***/ "9KlH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return checkAccessToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return checkRefreshToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return getTokens; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return deleteToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return deleteTokens; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return popAuthList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return getLoginRights; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return getOwnerdLoginRights; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return SelectConcurrentDepartment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return SelectAuthInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return SelectAuthCopyInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return EditAuth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return getEditHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return ProhibitedLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CreateEditHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return GetAuthTypeAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return GetAuthType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CreateAuthType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return EditAuthType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AuthTypeModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CreateAuthAllocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return GetAuthAllocationAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return GetAuthAllocaion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return EditAuthAllocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CreateFrontAuth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CreateApiAuth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FrontAuthModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthAllocaionShowCreate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AuthShowCreate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return AuthTypeShowCreate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_env_js__ = __webpack_require__("AMf1");


__WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.withCredentials = true;

var checkAccessToken = function checkAccessToken(shainNo, token) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__config_env_js__["c" /* authUrl */] + '/api/accessToken/check', {
    shain_no: shainNo,
    token: token
  });
};

var checkRefreshToken = function checkRefreshToken(shainNo, token) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__config_env_js__["c" /* authUrl */] + '/api/refreshToken/check', {
    shain_no: shainNo,
    token: token
  });
};

var getTokens = function getTokens(shainNo, tokenId) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__config_env_js__["c" /* authUrl */] + '/api/tokens/' + shainNo + '/' + tokenId);
};

var deleteToken = function deleteToken(shainNo, refreshToken) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__config_env_js__["c" /* authUrl */] + '/api/token/delete', {
    shain_no: shainNo,
    token: refreshToken + ''
  });
};

var deleteTokens = function deleteTokens(shainNo) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__config_env_js__["c" /* authUrl */] + '/api/tokens/delete/' + shainNo);
};

var popAuthList = function popAuthList(shainNo) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__config_env_js__["a" /* apiUrl */] + '/auth/get/' + shainNo);
};

var getLoginRights = function getLoginRights(shainNo) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__config_env_js__["c" /* authUrl */] + '/api/login/rights/' + shainNo);
};

var getOwnerdLoginRights = function getOwnerdLoginRights(loginRights) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__config_env_js__["c" /* authUrl */] + '/api/login/rights/all', {
    is_delete: loginRights
  });
};

var SelectConcurrentDepartment = function SelectConcurrentDepartment(ShainNo) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__config_env_js__["a" /* apiUrl */] + '/auth/get/concurrentDepartment/' + ShainNo);
};

var SelectAuthInfo = function SelectAuthInfo(ShainNoDigest) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__config_env_js__["a" /* apiUrl */] + '/auth/get/info/' + ShainNoDigest);
};

var SelectAuthCopyInfo = function SelectAuthCopyInfo(ShainNo, TargetShainNo) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__config_env_js__["a" /* apiUrl */] + '/auth/get/copyInfo', {
    'shain_no': ShainNo,
    'target_shain_no': TargetShainNo
  });
};

var EditAuth = function EditAuth(LoginUser, ShainNo, ConcurrentDepartmentId, AuthTypeId, Auth, AuthCopy) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_1__config_env_js__["a" /* apiUrl */] + '/auth/edit', {
    login_user: LoginUser,
    shain_no: ShainNo,
    concurrent_department_id: ConcurrentDepartmentId,
    auth_type_id: AuthTypeId,
    auth: Auth,
    auth_copy: AuthCopy
  });
};

/* export const EditAuth = (LoginUser,
  ShainNo,
  ConcurrentDepartmentId,
  InterviewList,
  SearchPerson,
  PlanList,
  Positioning,
  WorkersTransitive,
  InterviewRegister,
  PlanRegister,
  User,
  Office,
  Division,
  Post,
  AreaGroup,
  JobCategory,
  JobOffer,
  WorkerDetailItem) => {
  return axios.put(apiUrl + '/auth/edit', {
    login_user: LoginUser,
    shain_no: ShainNo,
    concurrent_department_id: ConcurrentDepartmentId,
    auth_type_id: AuthTypeId,
    auth: Auth
  })
} */

var getEditHistory = function getEditHistory(ShainNo) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__config_env_js__["a" /* apiUrl */] + '/auth/edit/history/' + ShainNo);
};

var ProhibitedLogin = function ProhibitedLogin(ShainNo, IsDelete) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__config_env_js__["c" /* authUrl */] + '/api/login/prohibit', {
    shain_no: ShainNo,
    is_delete: IsDelete
  });
};

var CreateEditHistory = function CreateEditHistory(ShainNo, FunctionNo, ChangeItemName, BeforeChange, AfterChange, UpdatedShain) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__config_env_js__["a" /* apiUrl */] + '/auth/editHistory/create', {
    shain_no: ShainNo,
    function_no: FunctionNo,
    change_item_name: ChangeItemName,
    before_change: BeforeChange,
    after_change: AfterChange,
    updated_shain: UpdatedShain
  });
};

var GetAuthTypeAll = function GetAuthTypeAll() {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__config_env_js__["a" /* apiUrl */] + '/authType');
};

var GetAuthType = function GetAuthType(Hash) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__config_env_js__["a" /* apiUrl */] + '/authType/' + Hash);
};

var CreateAuthType = function CreateAuthType(AuthType, AuthData) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__config_env_js__["a" /* apiUrl */] + '/authType', {
    auth_type: AuthType,
    auth_data: AuthData
  });
};

var EditAuthType = function EditAuthType(AuthType, AuthData) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_1__config_env_js__["a" /* apiUrl */] + '/authType', {
    auth_type: AuthType,
    auth_data: AuthData
  });
};

var AuthTypeModal = function AuthTypeModal(authData, useHidden) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__config_env_js__["a" /* apiUrl */] + '/authType/modal', {
    auth_data: authData,
    use_hidden: useHidden
  });
};

var CreateAuthAllocation = function CreateAuthAllocation(deptId, postId, authTypeId) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__config_env_js__["a" /* apiUrl */] + '/authAllocation', {
    dept_id: deptId,
    post_id: postId,
    auth_type_id: authTypeId
  });
};

var GetAuthAllocationAll = function GetAuthAllocationAll() {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__config_env_js__["a" /* apiUrl */] + '/authAllocation');
};

var GetAuthAllocaion = function GetAuthAllocaion(hash) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__config_env_js__["a" /* apiUrl */] + '/authAllocation/' + hash);
};

var EditAuthAllocation = function EditAuthAllocation(id, deptId, postId, authTypeId) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_1__config_env_js__["a" /* apiUrl */] + '/authAllocation', {
    auth_allocation_id: id,
    dept_id: deptId,
    post_id: postId,
    auth_type_id: authTypeId
  });
};

var CreateFrontAuth = function CreateFrontAuth(funcId, funcName) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__config_env_js__["a" /* apiUrl */] + '/frontAuth', {
    func_id: funcId,
    func_name: funcName
  });
};

var CreateApiAuth = function CreateApiAuth(funcId, apiId, apiName) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__config_env_js__["a" /* apiUrl */] + '/apiAuth', {
    func_id: funcId,
    api_id: apiId,
    api_name: apiName
  });
};

var FrontAuthModal = function FrontAuthModal(authData) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__config_env_js__["a" /* apiUrl */] + '/frontAuth/modal', authData);
};

var AuthAllocaionShowCreate = function AuthAllocaionShowCreate() {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__config_env_js__["a" /* apiUrl */] + '/authAllocation/create');
};

var AuthShowCreate = function AuthShowCreate() {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__config_env_js__["a" /* apiUrl */] + '/auth/create');
};

var AuthTypeShowCreate = function AuthTypeShowCreate() {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__config_env_js__["a" /* apiUrl */] + '/authType/create');
};

/***/ }),

/***/ "AMf1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

const apiUrl = '//back-hitolog.n-links.biz'
/* harmony export (immutable) */ __webpack_exports__["a"] = apiUrl;

const authUrl = '//auth.n-links.biz'
/* harmony export (immutable) */ __webpack_exports__["c"] = authUrl;

const myUrl = 'hitolog.n-links.biz'
/* harmony export (immutable) */ __webpack_exports__["d"] = myUrl;

const appName = 'hitolog'
/* harmony export (immutable) */ __webpack_exports__["b"] = appName;



/***/ }),

/***/ "AZxf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACCESS_TOKEN; });
/* unused harmony export REFRESH_TOKEN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SHAIN_NO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SHAIN_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AUTH_LEVEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SEARCH_SHAIN_NO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return POSITION_DISP_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return POSITION_FLG_LIST; });
/* unused harmony export OFFICEMASTER_ADDRESS */
/* unused harmony export OFFICEMASTER_OPEN_ON */
/* unused harmony export OFFICEMASTER_CLOSE_ON */
/* unused harmony export OFFICEMASTER_IS_HIDDEN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MENU; });
var ACCESS_TOKEN = 'ACCESS_TOKEN';
var REFRESH_TOKEN = 'REFRESH_TOKEN';
var SHAIN_NO = 'SHAIN_NO';
var SHAIN_NAME = 'SHAIN_NAME';
var AUTH_LEVEL = 'AUTH_LEVEL';
var SEARCH_SHAIN_NO = 'SEARCH_SHAIN_NO';
var POSITION_DISP_DATA = 'POSITION_DISP_DATA';
var POSITION_FLG_LIST = 'POSITION_FLG_LIST';
var OFFICEMASTER_ADDRESS = 'OFFICEMASTER_ADDRESS';
var OFFICEMASTER_OPEN_ON = 'OFFICEMASTER_OPEN_ON';
var OFFICEMASTER_CLOSE_ON = 'OFFICEMASTER_CLOSE_ON';
var OFFICEMASTER_IS_HIDDEN = 'OFFICEMASTER_IS_HIDDEN';
var MENU = 'MENU';

/***/ }),

/***/ "D+VX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_mutation_types_js__ = __webpack_require__("AZxf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_storage_js__ = __webpack_require__("laiv");


var _mutations, _actions;

/*
アクセストークン及びリフレッシュトークンは、2021年3月1日現在、localstorageにて管理・運用している
プロジェクト開始当初、Vuexで管理しようとしていたが、
何らかの理由でlocalstorageでの管理に切り替えた
コード自体は残しておくこととするが、機能してはいない
記録 山本
*/


// import api from '../../api/api.js'


var state = {
  accessToken: null,
  refreshToken: null,
  shainNo: null,
  shainName: '',
  authLevel: null
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__utils_mutation_types_js__["a" /* ACCESS_TOKEN */], function (state, _ref) {
  var token = _ref.token;

  // api.header(token)
  Object(__WEBPACK_IMPORTED_MODULE_2__utils_storage_js__["d" /* setSessionStore */])('ACCESS_TOKEN', token);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__utils_mutation_types_js__["h" /* SHAIN_NO */], function (state, _ref2) {
  var num = _ref2.num;

  state.shainNo = num;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__utils_mutation_types_js__["g" /* SHAIN_NAME */], function (state, _ref3) {
  var name = _ref3.name;

  state.shainName = name;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__utils_mutation_types_js__["b" /* AUTH_LEVEL */], function (state, _ref4) {
  var auth = _ref4.auth;

  state.authLevel = auth;
}), _mutations);

var getters = {
  getShainName: function getShainName(state) {
    return state.shainName;
  },
  getAccessToken: function getAccessToken(state) {
    return state.accessToken;
  }
};

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__utils_mutation_types_js__["a" /* ACCESS_TOKEN */], function (_ref5, token) {
  var commit = _ref5.commit;

  commit(__WEBPACK_IMPORTED_MODULE_1__utils_mutation_types_js__["a" /* ACCESS_TOKEN */], { token: token });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__utils_mutation_types_js__["h" /* SHAIN_NO */], function (_ref6, num) {
  var commit = _ref6.commit;

  commit(__WEBPACK_IMPORTED_MODULE_1__utils_mutation_types_js__["h" /* SHAIN_NO */], { num: num });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__utils_mutation_types_js__["g" /* SHAIN_NAME */], function (_ref7, name) {
  var commit = _ref7.commit;

  commit(__WEBPACK_IMPORTED_MODULE_1__utils_mutation_types_js__["g" /* SHAIN_NAME */], { name: name });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__utils_mutation_types_js__["b" /* AUTH_LEVEL */], function (_ref8, auth) {
  var commit = _ref8.commit;

  commit(__WEBPACK_IMPORTED_MODULE_1__utils_mutation_types_js__["b" /* AUTH_LEVEL */], { auth: auth });
}), _actions);

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "EpX4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_mutation_types_js__ = __webpack_require__("AZxf");


var _mutations;



var state = {
  disp_data: [],
  flg_list: {}
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__utils_mutation_types_js__["d" /* POSITION_DISP_DATA */], function (state, data) {
  state.disp_data = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__utils_mutation_types_js__["e" /* POSITION_FLG_LIST */], function (state, data) {
  state.flg_list = data;
}), _mutations);

var getters = {
  getDispData: function getDispData(state) {
    return state.disp_data;
  }
};

var actions = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_auth_js__ = __webpack_require__("D+VX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_search_js__ = __webpack_require__("dI8L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_positioning_js__ = __webpack_require__("EpX4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_transition_js__ = __webpack_require__("pyT+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex_persistedstate__ = __webpack_require__("424j");








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    auth: __WEBPACK_IMPORTED_MODULE_2__modules_auth_js__["a" /* default */],
    search: __WEBPACK_IMPORTED_MODULE_3__modules_search_js__["a" /* default */],
    positioning: __WEBPACK_IMPORTED_MODULE_4__modules_positioning_js__["a" /* default */],
    transition: __WEBPACK_IMPORTED_MODULE_5__modules_transition_js__["a" /* default */]
  },
  state: {
    loading: false,
    forbidden: false,
    jobOfferLoading: false
  },
  mutations: {
    onLoading: function onLoading(state, mode) {
      state.loading = mode;
    },
    forbidden: function forbidden(state, mode) {
      state.forbidden = mode;
    }
  },
  plugins: [Object(__WEBPACK_IMPORTED_MODULE_6_vuex_persistedstate__["a" /* default */])()]
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ "KF9i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validate_validate__ = __webpack_require__("9DFf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_index_js__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_at_ui__ = __webpack_require__("yweG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_at_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_at_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_at_ui_style__ = __webpack_require__("KF9i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_at_ui_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_at_ui_style__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




// import VueMdl from 'vue-mdl'

 // Import CSS

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_at_ui___default.a);
// Vue.use(VueMdl)

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_3__store_index_js__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<router-view></router-view>'
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_index_js__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_auth_index_js__ = __webpack_require__("9KlH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_restrict_access_index_js__ = __webpack_require__("4k6L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_user_index_js__ = __webpack_require__("v1eo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_utils_storage_js__ = __webpack_require__("laiv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_utils_app_whitelist_js__ = __webpack_require__("9KKl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config_env_js__ = __webpack_require__("AMf1");









var setToken = function setToken() {
  return __webpack_require__.e/* import() */(79).then(__webpack_require__.bind(null, "rcD0"));
};
var logout = function logout() {
  return __webpack_require__.e/* import() */(110).then(__webpack_require__.bind(null, "KDEu"));
};
var userAgent = function userAgent() {
  return __webpack_require__.e/* import() */(109).then(__webpack_require__.bind(null, "5Bt4"));
};
var app = function app() {
  return __webpack_require__.e/* import() */(77).then(__webpack_require__.bind(null, "EWfp"));
};
var top = function top() {
  return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, "eK/8"));
};
var noticeSetting = function noticeSetting() {
  return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, "DVC5"));
};
var person = function person() {
  return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, "2NpJ"));
};
var detail = function detail() {
  return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, "tauf"));
};
var personMemo = function personMemo() {
  return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, "fYu0"));
};
var timeLine = function timeLine() {
  return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, "9UBf"));
};
var profile = function profile() {
  return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, "LZXq"));
};
var positioning = function positioning() {
  return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, "wrxx"));
};
var wholeData = function wholeData() {
  return __webpack_require__.e/* import() */(49).then(__webpack_require__.bind(null, "n9eg"));
};
var interviewRegister = function interviewRegister() {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, "gvlV"));
};
var interviewList = function interviewList() {
  return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, "sNlH"));
};
var interviewContent = function interviewContent() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "9Vmm"));
};
var interviewRecordList = function interviewRecordList() {
  return __webpack_require__.e/* import() */(63).then(__webpack_require__.bind(null, "rzn2"));
};
var interviewRecordContent = function interviewRecordContent() {
  return __webpack_require__.e/* import() */(64).then(__webpack_require__.bind(null, "iPfd"));
};
var advanceConfirm = function advanceConfirm() {
  return __webpack_require__.e/* import() */(52).then(__webpack_require__.bind(null, "zIa9"));
};
var advanceConfirmDetail = function advanceConfirmDetail() {
  return __webpack_require__.e/* import() */(107).then(__webpack_require__.bind(null, "nXgg"));
};
var advanceConfirmEdit = function advanceConfirmEdit() {
  return __webpack_require__.e/* import() */(70).then(__webpack_require__.bind(null, "Z7aC"));
};
var advanceConfirmAnser = function advanceConfirmAnser() {
  return __webpack_require__.e/* import() */(91).then(__webpack_require__.bind(null, "hilz"));
};
var transitive = function transitive() {
  return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, "sJcQ"));
};
var area = function area() {
  return __webpack_require__.e/* import() */(88).then(__webpack_require__.bind(null, "klPo"));
};
var areaDetail = function areaDetail() {
  return __webpack_require__.e/* import() */(67).then(__webpack_require__.bind(null, "m9N8"));
};
var jobCategory = function jobCategory() {
  return __webpack_require__.e/* import() */(104).then(__webpack_require__.bind(null, "G8Du"));
};
var jobCategoryEdit = function jobCategoryEdit() {
  return __webpack_require__.e/* import() */(98).then(__webpack_require__.bind(null, "7Niy"));
};
var jobOffer = function jobOffer() {
  return __webpack_require__.e/* import() */(80).then(__webpack_require__.bind(null, "20KY"));
};
var jobMediaEdit = function jobMediaEdit() {
  return __webpack_require__.e/* import() */(75).then(__webpack_require__.bind(null, "pJb+"));
};
var hrIntroductionEdit = function hrIntroductionEdit() {
  return __webpack_require__.e/* import() */(76).then(__webpack_require__.bind(null, "Ibn5"));
};
var schoolIntroductionEdit = function schoolIntroductionEdit() {
  return __webpack_require__.e/* import() */(74).then(__webpack_require__.bind(null, "XqQ0"));
};
var office = function office() {
  return __webpack_require__.e/* import() */(48).then(__webpack_require__.bind(null, "bc1Q"));
};
var officeDetail = function officeDetail() {
  return __webpack_require__.e/* import() */(59).then(__webpack_require__.bind(null, "NI/A"));
};
var post = function post() {
  return __webpack_require__.e/* import() */(84).then(__webpack_require__.bind(null, "Rm3x"));
};
var postDetail = function postDetail() {
  return __webpack_require__.e/* import() */(96).then(__webpack_require__.bind(null, "EbZB"));
};
var division = function division() {
  return __webpack_require__.e/* import() */(66).then(__webpack_require__.bind(null, "B/p5"));
};
var divisionDetail = function divisionDetail() {
  return __webpack_require__.e/* import() */(93).then(__webpack_require__.bind(null, "IhMv"));
};
var user = function user() {
  return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, "aJGe"));
};
var userDetail = function userDetail() {
  return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, "Dfqf"));
};
var userEdit = function userEdit() {
  return __webpack_require__.e/* import() */(65).then(__webpack_require__.bind(null, "T/v1"));
};
var workerDetailItem = function workerDetailItem() {
  return __webpack_require__.e/* import() */(81).then(__webpack_require__.bind(null, "hAlb"));
};
var workerDetailItemEdit = function workerDetailItemEdit() {
  return __webpack_require__.e/* import() */(97).then(__webpack_require__.bind(null, "fExz"));
};
var authType = function authType() {
  return __webpack_require__.e/* import() */(86).then(__webpack_require__.bind(null, "vajk"));
};
var authTypeEdit = function authTypeEdit() {
  return __webpack_require__.e/* import() */(78).then(__webpack_require__.bind(null, "sfNK"));
};
var authAllocation = function authAllocation() {
  return __webpack_require__.e/* import() */(106).then(__webpack_require__.bind(null, "ZZZd"));
};
var authAllocationEdit = function authAllocationEdit() {
  return __webpack_require__.e/* import() */(68).then(__webpack_require__.bind(null, "aoI7"));
};
var createAuth = function createAuth() {
  return __webpack_require__.e/* import() */(90).then(__webpack_require__.bind(null, "x1vX"));
};
var publicRecruitment = function publicRecruitment() {
  return __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, "LNks"));
};
var publicRecruitmentRegister = function publicRecruitmentRegister() {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, "ygow"));
};
var publicRecruitmentApplication = function publicRecruitmentApplication() {
  return __webpack_require__.e/* import() */(100).then(__webpack_require__.bind(null, "rL2Q"));
};
var publicRecruitmentSearch = function publicRecruitmentSearch() {
  return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, "f4Jq"));
};
var publicRecruitmentDetail = function publicRecruitmentDetail() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "9Uug"));
};
var publicRecruitmentRecordList = function publicRecruitmentRecordList() {
  return __webpack_require__.e/* import() */(62).then(__webpack_require__.bind(null, "Fa6E"));
};
var publicRecruitmentRecordContent = function publicRecruitmentRecordContent() {
  return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, "8V8R"));
};
var publicRecruitmentAdvanceConfirm = function publicRecruitmentAdvanceConfirm() {
  return __webpack_require__.e/* import() */(89).then(__webpack_require__.bind(null, "9RjC"));
};
var publicRecruitmentCategory = function publicRecruitmentCategory() {
  return __webpack_require__.e/* import() */(103).then(__webpack_require__.bind(null, "IZui"));
};
var publicRecruitmentCategoryEdit = function publicRecruitmentCategoryEdit() {
  return __webpack_require__.e/* import() */(73).then(__webpack_require__.bind(null, "B/z0"));
};
var publicRecruitmentSheet = function publicRecruitmentSheet() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, "AYud"));
};
var retirePlanRegister = function retirePlanRegister() {
  return __webpack_require__.e/* import() */(57).then(__webpack_require__.bind(null, "RpkE"));
};
var retirePlanList = function retirePlanList() {
  return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, "ScTl"));
};
var retirePlanDetail = function retirePlanDetail() {
  return __webpack_require__.e/* import() */(60).then(__webpack_require__.bind(null, "2W0W"));
};
var fixDataRegister = function fixDataRegister() {
  return __webpack_require__.e/* import() */(92).then(__webpack_require__.bind(null, "PUkH"));
};
var workersArragement = function workersArragement() {
  return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, "njmm"));
};
var employStatusGroup = function employStatusGroup() {
  return __webpack_require__.e/* import() */(105).then(__webpack_require__.bind(null, "QgLn"));
};
var employStatusGroupEdit = function employStatusGroupEdit() {
  return __webpack_require__.e/* import() */(72).then(__webpack_require__.bind(null, "HCB7"));
};
var rewardAndPunishmentItem = function rewardAndPunishmentItem() {
  return __webpack_require__.e/* import() */(82).then(__webpack_require__.bind(null, "zDII"));
};
var rewardAndPunishmentItemEdit = function rewardAndPunishmentItemEdit() {
  return __webpack_require__.e/* import() */(94).then(__webpack_require__.bind(null, "XHzB"));
};
var rewardAndPunishmentCategoryEdit = function rewardAndPunishmentCategoryEdit() {
  return __webpack_require__.e/* import() */(99).then(__webpack_require__.bind(null, "8rRW"));
};
var rewardAndPunishmentRegister = function rewardAndPunishmentRegister() {
  return __webpack_require__.e/* import() */(51).then(__webpack_require__.bind(null, "l3aa"));
};
var rewardAndPunishmentSearch = function rewardAndPunishmentSearch() {
  return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, "3RuS"));
};
var rewardAndPunishmentDetail = function rewardAndPunishmentDetail() {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, "ICNB"));
};
var segment = function segment() {
  return __webpack_require__.e/* import() */(102).then(__webpack_require__.bind(null, "hk2f"));
};
var segmentEdit = function segmentEdit() {
  return __webpack_require__.e/* import() */(71).then(__webpack_require__.bind(null, "/7xM"));
};
var boardOfDirectorsDocument = function boardOfDirectorsDocument() {
  return __webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, "fyXQ"));
};
var dept = function dept() {
  return __webpack_require__.e/* import() */(85).then(__webpack_require__.bind(null, "xmc0"));
};
var deptDetail = function deptDetail() {
  return __webpack_require__.e/* import() */(108).then(__webpack_require__.bind(null, "eO5g"));
};
var recruitDiv = function recruitDiv() {
  return __webpack_require__.e/* import() */(83).then(__webpack_require__.bind(null, "a6PO"));
};
var transferHopeRegister = function transferHopeRegister() {
  return __webpack_require__.e/* import() */(58).then(__webpack_require__.bind(null, "TRkV"));
};
var transferHopeSearch = function transferHopeSearch() {
  return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, "hMwO"));
};
var transferHopeDetail = function transferHopeDetail() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, "f3Qq"));
};
var transferHopeRecordList = function transferHopeRecordList() {
  return __webpack_require__.e/* import() */(61).then(__webpack_require__.bind(null, "HMzg"));
};
var transferHopeRecordContent = function transferHopeRecordContent() {
  return __webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, "/gqi"));
};
var transferPossible = function transferPossible() {
  return __webpack_require__.e/* import() */(101).then(__webpack_require__.bind(null, "1lds"));
};
var transferPossibleEdit = function transferPossibleEdit() {
  return __webpack_require__.e/* import() */(69).then(__webpack_require__.bind(null, "wg05"));
};
var group = function group() {
  return __webpack_require__.e/* import() */(87).then(__webpack_require__.bind(null, "Mq2R"));
};
var groupDetail = function groupDetail() {
  return __webpack_require__.e/* import() */(56).then(__webpack_require__.bind(null, "u2ok"));
};
var groupEdit = function groupEdit() {
  return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, "zyjr"));
};
var absentWithoutRegister = function absentWithoutRegister() {
  return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, "cUdL"));
};
var absentWithoutSearch = function absentWithoutSearch() {
  return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, "KHgU"));
};
var absentWithoutDetail = function absentWithoutDetail() {
  return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, "nGMi"));
};
var minutesRegister = function minutesRegister() {
  return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, "kUDL"));
};
var minutesSearch = function minutesSearch() {
  return __webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, "6NxM"));
};
var minutesDetail = function minutesDetail() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "We1Y"));
};
var minutesEdit = function minutesEdit() {
  return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, "7Hos"));
};
var minutesAgendaRegister = function minutesAgendaRegister() {
  return __webpack_require__.e/* import() */(95).then(__webpack_require__.bind(null, "zHrQ"));
};
var minutesAgendaDetail = function minutesAgendaDetail() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, "GEIV"));
};
var retireeManagementSearch = function retireeManagementSearch() {
  return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, "y2Ak"));
};
var retireeManagementDetail = function retireeManagementDetail() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "LVYu"));
};
var transferPlanDeadline = function transferPlanDeadline() {
  return __webpack_require__.e/* import() */(53).then(__webpack_require__.bind(null, "zo5k"));
};
var transferPlanDeadlineEdit = function transferPlanDeadlineEdit() {
  return __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, "Jqsp"));
};
var transferPlanRegister = function transferPlanRegister() {
  return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, "zCjv"));
};
var transferPlanSearch = function transferPlanSearch() {
  return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, "L386"));
};
var transferPlanDetail = function transferPlanDetail() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, "wE0u"));
};
var transferPlanApprovalSearch = function transferPlanApprovalSearch() {
  return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, "TF80"));
};
var transferPlanApprovalDetail = function transferPlanApprovalDetail() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, "xbAW"));
};
var transferManagementSearch = function transferManagementSearch() {
  return __webpack_require__.e/* import() */(50).then(__webpack_require__.bind(null, "29Vd"));
};
var transferManagementDetail = function transferManagementDetail() {
  return __webpack_require__.e/* import() */(54).then(__webpack_require__.bind(null, "VYhd"));
};
var leaveOfAbsenceRegister = function leaveOfAbsenceRegister() {
  return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, "AwR9"));
};
var leaveOfAbsenceSearch = function leaveOfAbsenceSearch() {
  return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, "YXuZ"));
};
var leaveOfAbsenceDetail = function leaveOfAbsenceDetail() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "G35H"));
};
var leaveOfAbsenceConfirm = function leaveOfAbsenceConfirm() {
  return __webpack_require__.e/* import() */(55).then(__webpack_require__.bind(null, "dbKx"));
};
// Nlog廃止に伴ってコメントアウト 2024/08/22 赤坂
// const resultManagementRegister = () => import('../components/result_management/register/Register.vue')
// const resultManagementSearch = () => import('../components/result_management/search/Search.vue')
// const resultManagementDetail = () => import('../components/result_management/detail/Detail.vue')
// const resultManagementRecordList = () => import('../components/result_management/record/List.vue')
// const resultManagementRecordContent = () => import('../components/result_management/record/Content.vue')

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  mode: 'history',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: [{
    path: '/setToken/:shainNo/:tokenId',
    name: 'setToken',
    component: setToken,
    meta: { requireAuth: false }
  }, {
    path: '/unsupported',
    name: 'unsupported',
    component: userAgent,
    meta: { requireAuth: false }
  }, {
    path: '/',
    component: app,
    redirect: 'top',
    children: [{
      path: '/logout',
      name: 'logout',
      component: logout,
      meta: {
        requireAuth: true,
        menu: 0
      }
    }, {
      path: 'top',
      component: top,
      meta: {
        requireAuth: true,
        menu: 0
      }
    }, {
      path: 'profile',
      component: profile,
      meta: {
        requireAuth: true,
        menu: 901
      }
    }, {
      path: 'noticeSetting',
      component: noticeSetting,
      meta: {
        requireAuth: true,
        menu: 904
      }
    }, {
      path: 'search/person',
      component: person,
      meta: {
        requireAuth: true,
        menu: 101
      }
    }, {
      path: 'search/:worker_detail_id_digest',
      component: detail,
      meta: {
        requireAuth: true,
        menu: 101
      }
    }, {
      path: 'search/memo/:worker_detail_id_digest',
      component: personMemo,
      meta: {
        requireAuth: true,
        menu: 101
      }
    }, {
      path: 'search/timeLine/:shain_no_digest',
      component: timeLine,
      meta: {
        requireAuth: true,
        menu: 101
      }
    }, {
      path: 'positioning',
      component: positioning,
      meta: {
        requireAuth: true,
        menu: 201
      }
    }, {
      path: 'publicRecruitment/search',
      component: publicRecruitmentSearch,
      meta: {
        requireAuth: true,
        menu: 104
      }
    }, {
      path: 'publicRecruitment/search/:hash',
      component: publicRecruitmentDetail,
      meta: {
        requireAuth: true,
        menu: 104
      }
    }, {
      path: 'publicRecruitmentSheet/:hash',
      component: publicRecruitmentSheet,
      meta: {
        requireAuth: true,
        menu: 104
      }
    }, {
      path: 'positioning/wholeData',
      component: wholeData,
      meta: {
        requireAuth: true,
        menu: 201
      }
    }, {
      path: 'interview/register',
      component: interviewRegister,
      meta: {
        requireAuth: true,
        menu: 301
      }
    }, {
      path: 'interview/list',
      component: interviewList,
      meta: {
        requireAuth: true,
        menu: 102
      }
    }, {
      path: 'interview/content/:hash',
      component: interviewContent,
      meta: {
        requireAuth: true,
        menu: 102
      }
    }, {
      path: 'interviewRecord/list',
      component: interviewRecordList,
      meta: {
        requireAuth: true,
        menu: 902
      }
    }, {
      path: 'interviewRecord/:hash',
      component: interviewRecordContent,
      meta: {
        requireAuth: true,
        menu: 902
      }
    }, {
      path: 'advanceConfirm',
      component: advanceConfirm,
      meta: {
        requireAuth: true,
        menu: 303
      }
    }, {
      path: 'advanceConfirmDetail/:advance_confirm_hash',
      component: advanceConfirmDetail,
      meta: {
        requireAuth: true,
        menu: 303
      }
    }, {
      path: 'advanceConfirmEdit/:advance_confirm_hash',
      component: advanceConfirmEdit,
      meta: {
        requireAuth: true,
        menu: 303
      }
    }, {
      path: '/advanceConfirmAnswer/:interview_id',
      component: advanceConfirmAnser,
      meta: {
        requireAuth: true,
        menu: 0
      }
    }, {
      path: '/publicRecruitmentAdvanceConfirmAnswer/:hash',
      component: publicRecruitmentAdvanceConfirm,
      meta: {
        requireAuth: true,
        menu: 0
      }
    }, {
      path: 'publicRecruitment',
      component: publicRecruitment,
      meta: {
        requireAuth: true,
        menu: 304
      }
    }, {
      path: 'publicRecruitment/:hash',
      component: publicRecruitmentRegister,
      meta: {
        requireAuth: true,
        menu: 304
      }
    }, { path: 'publicRecruitmentApplication/:hash',
      component: publicRecruitmentApplication,
      meta: {
        requireAuth: true,
        menu: 104
      }
    }, {
      path: 'publicRecruitmentRecord/list',
      component: publicRecruitmentRecordList,
      meta: {
        requireAuth: true,
        menu: 903
      }
    }, {
      path: 'publicRecruitmentRecord/:hash',
      component: publicRecruitmentRecordContent,
      meta: {
        requireAuth: true,
        menu: 903
      }
    }, {
      path: 'workers_transitive',
      component: transitive,
      meta: {
        requireAuth: true,
        menu: 202
      }
    }, {
      path: 'area',
      component: area,
      meta: {
        requireAuth: true,
        menu: 405
      }
    }, {
      path: 'area/:area_id_digest',
      component: areaDetail,
      meta: {
        requireAuth: true,
        menu: 405
      }
    }, {
      path: 'jobOffer',
      component: jobOffer,
      meta: {
        requireAuth: true,
        menu: 407
      }
    }, {
      path: 'jobMediaEdit/:job_offer_id_digest',
      component: jobMediaEdit,
      meta: {
        requireAuth: true,
        menu: 407
      }
    }, {
      path: 'hrIntroductionEdit/:job_offer_id_digest',
      component: hrIntroductionEdit,
      meta: {
        requireAuth: true,
        menu: 407
      }
    }, {
      path: 'schoolIntroductionEdit/:job_offer_id_digest',
      component: schoolIntroductionEdit,
      meta: {
        requireAuth: true,
        menu: 407
      }
    }, {
      path: 'jobCategory',
      component: jobCategory,
      meta: {
        requireAuth: true,
        menu: 406
      }
    }, {
      path: 'jobCategory/:job_id_digest',
      component: jobCategoryEdit,
      meta: {
        requireAuth: true,
        menu: 406
      }
    }, {
      path: 'office',
      component: office,
      meta: {
        requireAuth: true,
        menu: 402
      }
    }, {
      path: 'office/:office_id_digest',
      component: officeDetail,
      meta: {
        requireAuth: true,
        menu: 402
      }
    }, {
      path: 'post',
      component: post,
      meta: {
        requireAuth: true,
        menu: 404
      }
    },
    /* 役職の並び順変更は権限、名称グループにも影響があるため、一旦編集不可に。
    2020/04/01 赤坂
    カラーコード設定のため、編集できるように設定変更
    2020/06/15 山本
    */
    {
      path: 'post/:post_id_digest',
      component: postDetail,
      meta: {
        requireAuth: true,
        menu: 404
      }
    }, {
      path: 'division',
      component: division,
      meta: {
        requireAuth: true,
        menu: 403
      }
    }, {
      path: 'division/:division_id_digest',
      component: divisionDetail,
      meta: {
        requireAuth: true,
        menu: 403
      }
    }, {
      path: 'user',
      component: user,
      meta: {
        requireAuth: true,
        menu: 401
      }
    }, {
      path: 'userDetail/:shain_no_digest',
      component: userDetail,
      meta: {
        requireAuth: true,
        menu: 401
      }
    }, {
      path: 'userEdit/:shain_no_digest',
      component: userEdit,
      meta: {
        requireAuth: true,
        menu: 401
      }
    }, {
      path: 'workerDetailItem',
      component: workerDetailItem,
      meta: {
        requireAuth: true,
        menu: 408
      }
    }, {
      path: 'workerDetailItem/:worker_detail_item_id_digest',
      component: workerDetailItemEdit,
      meta: {
        requireAuth: true,
        menu: 408
      }
    }, {
      path: 'authType',
      component: authType,
      meta: {
        requireAuth: true,
        menu: 409
      }
    }, {
      path: 'authType/:auth_type_hash',
      component: authTypeEdit,
      meta: {
        requireAuth: true,
        menu: 409
      }
    }, {
      path: 'authAllocation',
      component: authAllocation,
      meta: {
        requireAuth: true,
        menu: 410
      }
    }, {
      path: 'authAllocation/:auth_allocation_hash',
      component: authAllocationEdit,
      meta: {
        requireAuth: true,
        menu: 410
      }
    }, {
      path: 'publicRecruitmentCategory',
      component: publicRecruitmentCategory,
      meta: {
        requireAuth: true,
        menu: 411
      }
    }, {
      path: 'publicRecruitmentCategoryEdit/:hash',
      component: publicRecruitmentCategoryEdit,
      meta: {
        requireAuth: true,
        menu: 411
      }
    }, {
      path: 'segment',
      component: segment,
      meta: {
        requireAuth: true,
        menu: 412
      }
    }, {
      path: 'segmentEdit/:hash',
      component: segmentEdit,
      meta: {
        requireAuth: true,
        menu: 412
      }
    }, {
      path: 'employStatusGroup',
      component: employStatusGroup,
      meta: {
        requireAuth: true,
        menu: 414
      }
    }, {
      path: 'employStatusGroupEdit',
      component: employStatusGroupEdit,
      meta: {
        requireAuth: true,
        menu: 414
      }
    }, {
      path: 'dept',
      component: dept,
      meta: {
        requireAuth: true,
        menu: 420
      }
    }, {
      path: 'dept/:dept_id_digest',
      component: deptDetail,
      meta: {
        requireAuth: true,
        menu: 420
      }
    }, {
      path: 'recruit',
      component: recruitDiv,
      meta: {
        requireAuth: true,
        menu: 421
      }
    }, {
      path: 'createAuth',
      component: createAuth,
      meta: {
        requireAuth: true,
        menu: 501
      }
    }, {
      path: 'retirePlanRegister',
      component: retirePlanRegister,
      meta: {
        requireAuth: true,
        menu: 305
      }
    }, {
      path: 'retirePlan/list',
      component: retirePlanList,
      meta: {
        requireAuth: true,
        menu: 105
      }
    }, {
      path: 'retirePlan/:hash',
      component: retirePlanDetail,
      meta: {
        requireAuth: true,
        menu: 105
      }
    }, {
      path: 'fixDataRegister',
      component: fixDataRegister,
      meta: {
        requireAuth: true,
        menu: 306
      }
    }, {
      path: 'workersArrangement',
      component: workersArragement,
      meta: {
        requireAuth: true,
        menu: 203
      }
    }, {
      path: 'rewardAndPunishmentItem',
      component: rewardAndPunishmentItem,
      meta: {
        requireAuth: true,
        menu: 413
      }
    }, {
      path: 'rewardAndPunishmentItemEdit/:hash',
      component: rewardAndPunishmentItemEdit,
      meta: {
        requireAuth: true,
        menu: 413
      }
    }, {
      path: 'rewardAndPunishmentCategoryEdit',
      component: rewardAndPunishmentCategoryEdit,
      meta: {
        requireAuth: true,
        menu: 413
      }
    }, {
      path: 'rewardAndPunishmentRegister',
      component: rewardAndPunishmentRegister,
      meta: {
        requireAuth: true,
        menu: 307
      }
    }, {
      path: 'rewardAndPunishmentSearch',
      component: rewardAndPunishmentSearch,
      meta: {
        requireAuth: true,
        menu: 106
      }
    }, {
      path: 'rewardAndPunishmentDetail/:hash',
      component: rewardAndPunishmentDetail,
      meta: {
        requireAuth: true,
        menu: 106
      }
    }, {
      path: 'boardOfDirectorsSearch',
      component: boardOfDirectorsDocument,
      meta: {
        requireAuth: true,
        menu: 107
      }
    },
    // Nlog廃止に伴ってコメントアウト 2024/08/22 赤坂
    // {
    //   path: 'resultManagementRegister',
    //   component: resultManagementRegister,
    //   meta: {
    //     requireAuth: true,
    //     menu: 308
    //   }
    // },
    // {
    //   path: 'resultManagementSearch',
    //   component: resultManagementSearch,
    //   meta: {
    //     requireAuth: true,
    //     menu: 108
    //   }
    // },
    // {
    //   path: 'resultManagementDetail/:hash',
    //   component: resultManagementDetail,
    //   meta: {
    //     requireAuth: true,
    //     menu: 108
    //   }
    // },
    // {
    //   path: 'resultManagementRecord/list',
    //   component: resultManagementRecordList,
    //   meta: {
    //     requireAuth: true,
    //     menu: 905
    //   }
    // },
    // {
    //   path: 'resultManagementRecord/:hash',
    //   component: resultManagementRecordContent,
    //   meta: {
    //     requireAuth: true,
    //     menu: 905
    //   }
    // },
    {
      path: 'transferHopeRegister',
      component: transferHopeRegister,
      meta: {
        requireAuth: true,
        menu: 309
      }
    }, {
      path: 'transferHopeSearch',
      component: transferHopeSearch,
      meta: {
        requireAuth: true,
        menu: 109
      }
    }, {
      path: 'transferHopeDetail/:hash',
      component: transferHopeDetail,
      meta: {
        requireAuth: true,
        menu: 109
      }
    }, {
      path: 'transferHopeRecord',
      component: transferHopeRecordList,
      meta: {
        requireAuth: true,
        menu: 906
      }
    }, {
      path: 'transferHopeRecord/:hash',
      component: transferHopeRecordContent,
      meta: {
        requireAuth: true,
        menu: 906
      }
    }, {
      path: 'transferPossible',
      component: transferPossible,
      meta: {
        requireAuth: true,
        menu: 417
      }
    }, {
      path: 'transferPossibleEdit/:hash',
      component: transferPossibleEdit,
      meta: {
        requireAuth: true,
        menu: 417
      }
    }, {
      path: '/group',
      component: group,
      meta: {
        requireAuth: true,
        menu: 418
      }
    }, {
      path: '/groupDetail/:hash',
      component: groupDetail,
      meta: {
        requireAuth: true,
        menu: 418
      }
    }, {
      path: '/groupEdit/:hash',
      component: groupEdit,
      meta: {
        requireAuth: true,
        menu: 418
      }
    }, {
      path: '/absentWithoutRegister',
      component: absentWithoutRegister,
      meta: {
        requireAuth: true,
        menu: 310
      }
    }, {
      path: '/absentWithoutSearch',
      component: absentWithoutSearch,
      meta: {
        requireAuth: true,
        menu: 110
      }
    }, {
      path: '/absentWithout/:hash',
      component: absentWithoutDetail,
      meta: {
        requireAuth: true,
        menu: 110
      }
    }, {
      path: '/minutesRegister',
      component: minutesRegister,
      meta: {
        requireAuth: true,
        menu: 311
      }
    }, {
      path: '/minutesSearch',
      component: minutesSearch,
      meta: {
        requireAuth: true,
        menu: 111
      }
    }, {
      path: '/minutesDetail/:hash',
      component: minutesDetail,
      meta: {
        requireAuth: true,
        menu: 111
      }
    }, {
      path: '/minutesEdit/:hash',
      component: minutesEdit,
      meta: {
        requireAuth: true,
        menu: 111
      }
    }, {
      path: '/minutesAgendaRegister/:minutesHash',
      component: minutesAgendaRegister,
      meta: {
        requireAuth: true,
        menu: 111
      }
    }, {
      path: '/minutesAgendaDetail/:agendaHash',
      component: minutesAgendaDetail,
      meta: {
        requireAuth: true,
        menu: 111
      }
    }, {
      path: '/retireeManagement/search',
      component: retireeManagementSearch,
      meta: {
        requireAuth: true,
        menu: 112
      }
    }, {
      path: '/retireeManagement/:hash',
      component: retireeManagementDetail,
      meta: {
        requireAuth: true,
        menu: 112
      }
    }, {
      path: '/transferPlanDeadline',
      component: transferPlanDeadline,
      meta: {
        requireAuth: true,
        menu: 419
      }
    }, {
      path: '/transferPlanDeadline/edit/:targetYear',
      component: transferPlanDeadlineEdit,
      meta: {
        requireAuth: true,
        menu: 419
      }
    }, {
      path: 'transferPlanRegister',
      component: transferPlanRegister,
      meta: {
        requireAuth: true,
        menu: 312
      }
    }, {
      path: 'transferPlan/search',
      component: transferPlanSearch,
      meta: {
        requireAuth: true,
        menu: 113
      }
    }, {
      path: 'transferPlan/:hash',
      component: transferPlanDetail,
      meta: {
        requireAuth: true,
        menu: 113
      }
    }, {
      path: 'transferPlan/approval/search',
      component: transferPlanApprovalSearch,
      meta: {
        requireAuth: true,
        menu: 601
      }
    }, {
      path: 'transferPlan/approval/:hash',
      component: transferPlanApprovalDetail,
      meta: {
        requireAuth: true,
        menu: 601
      }
    }, {
      path: 'transferManagement/search',
      component: transferManagementSearch,
      meta: {
        requireAuth: true,
        menu: 114
      }
    }, {
      path: 'transferManagement/:year/:month',
      component: transferManagementDetail,
      meta: {
        requireAuth: true,
        menu: 114
      }
    }, {
      path: '/leaveOfAbsence/register',
      component: leaveOfAbsenceRegister,
      meta: {
        requireAuth: true,
        menu: 313
      }
    }, {
      path: '/leaveOfAbsence/search',
      component: leaveOfAbsenceSearch,
      meta: {
        requireAuth: true,
        menu: 115
      }
    }, {
      path: '/leaveOfAbsence/:hash',
      component: leaveOfAbsenceDetail,
      meta: {
        requireAuth: true,
        menu: 115
      }
    }, {
      path: '/leaveOfAbsence/confirm/:hash',
      component: leaveOfAbsenceConfirm,
      meta: {
        requireAuth: true,
        menu: 115
      }
    }]
  }, {
    path: '*',
    redirect: 'top'
  }]
});

// ログイン認証はここで行う
router.beforeEach(function (to, from, next) {
  var userAgent = window.navigator.userAgent.toLowerCase();

  // アプリの起動
  appOpen(userAgent);

  // 非対応ブラウザ判定
  if (!unsupported(to, next, userAgent)) {
    return;
  }

  // アプリ利用可能画面判定
  if (!appWhitelistCheck(to, next, userAgent)) {
    return;
  }

  // 権限チェック不要ページは次の処理へ
  if (!to.meta.requireAuth) {
    next();
    return;
  }

  // フロント権限確認
  frontAuthCheck(to.meta.menu, next);

  __WEBPACK_IMPORTED_MODULE_4__api_restrict_access_index_js__["a" /* CheckIp */](to.path).then(function (r) {
    __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].commit('forbidden', false);
    __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].commit('onLoading', true);
    __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].dispatch('transition/MENU', to.meta.menu);
    var accessToken = Object(__WEBPACK_IMPORTED_MODULE_6__store_utils_storage_js__["a" /* getLocalStore */])('ACCESS_TOKEN');
    var refreshToken = Object(__WEBPACK_IMPORTED_MODULE_6__store_utils_storage_js__["a" /* getLocalStore */])('REFRESH_TOKEN');
    var shainNo = Object(__WEBPACK_IMPORTED_MODULE_6__store_utils_storage_js__["a" /* getLocalStore */])('SHAIN_NO');
    if (shainNo && accessToken && refreshToken) {
      __WEBPACK_IMPORTED_MODULE_3__api_auth_index_js__["v" /* checkAccessToken */](shainNo, accessToken).then(function (res) {
        // store.dispatch('auth/SHAIN_NAME', 'てらしましょうへい')
        dispatchShainName(shainNo, ['ShainName']);
        next();
      }).catch(function (res) {
        var refreshToken = Object(__WEBPACK_IMPORTED_MODULE_6__store_utils_storage_js__["a" /* getLocalStore */])('REFRESH_TOKEN');
        __WEBPACK_IMPORTED_MODULE_3__api_auth_index_js__["w" /* checkRefreshToken */](shainNo, refreshToken).then(function (r) {
          dispatchShainName(shainNo, ['ShainName']);
          next();
        }).catch(function (r) {
          resetRedirect();
        });
      });
    } else {
      resetRedirect();
    }
  }).catch(function (e) {
    console.log(e);
    __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].commit('forbidden', true);
    next();
  });
});

function dispatchShainName(shainNo, name) {
  if (!__WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.auth.shainName) {
    __WEBPACK_IMPORTED_MODULE_5__api_user_index_js__["g" /* getShainInfo */](shainNo, name).then(function (r) {
      __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].dispatch('auth/SHAIN_NAME', r.data.ShainName);
    }).catch(function (e) {
      console.log(e);
    });
  }
}

function resetRedirect() {
  Object(__WEBPACK_IMPORTED_MODULE_6__store_utils_storage_js__["b" /* removeLocalStore */])('ACCESS_TOKEN');
  Object(__WEBPACK_IMPORTED_MODULE_6__store_utils_storage_js__["b" /* removeLocalStore */])('REFRESH_TOKEN');
  Object(__WEBPACK_IMPORTED_MODULE_6__store_utils_storage_js__["b" /* removeLocalStore */])('SHAIN_NO');
  Object(__WEBPACK_IMPORTED_MODULE_6__store_utils_storage_js__["b" /* removeLocalStore */])('AUTH_LIST');
  __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].dispatch('auth/SHAIN_NAME', '');
  var pathname = location.pathname;
  location.href = __WEBPACK_IMPORTED_MODULE_8__config_env_js__["c" /* authUrl */] + '/login?' + 'url=' + __WEBPACK_IMPORTED_MODULE_8__config_env_js__["d" /* myUrl */] + '/setToken' + '&transition=' + pathname;
}

function appOpen(userAgent) {
  if (userAgent.indexOf('hitologapp') === -1) {
    var target = ['iphone', 'android', 'ipad', 'ipod'];
    var len = target.length;
    for (var i = 0; i < len; ++i) {
      if (userAgent.indexOf(target[i]) > -1) {
        var host = location.hostname;
        var path = location.pathname;
        var parameter = '?host=' + host + '&path=' + path;
        location.href = 'appname://' + __WEBPACK_IMPORTED_MODULE_8__config_env_js__["b" /* appName */] + parameter;
        break;
      }
    }
  }
}

function unsupported(to, next, userAgent) {
  var res = true;
  if (userAgent.indexOf('msie') > -1 || userAgent.indexOf('trident') > -1) {
    if (to.path !== '/unsupported') {
      res = false;
      next({ path: '/unsupported' });
    }
  }
  return res;
}

function appWhitelistCheck(to, next, userAgent) {
  if (userAgent.indexOf('hitologapp') === -1 || to.path === '/top') {
    return true;
  }
  var res = false;
  var split = to.path.split('/');
  var splitLen = split.length;
  var x = __WEBPACK_IMPORTED_MODULE_7__store_utils_app_whitelist_js__["a" /* appWhitelist */].length;
  for (var a = 0; a < x; ++a) {
    var y = __WEBPACK_IMPORTED_MODULE_7__store_utils_app_whitelist_js__["a" /* appWhitelist */][a].length;
    for (var b = 0; b < y; ++b) {
      if (b <= splitLen && split[b + 1] === __WEBPACK_IMPORTED_MODULE_7__store_utils_app_whitelist_js__["a" /* appWhitelist */][a][b]) {
        if (b - 0 === y - 1) {
          res = true;
          break;
        }
      } else {
        break;
      }
    }
    if (res) break;
  }
  if (!res) next({ path: '/top' });
  return res;
}

function frontAuthCheck(menu, next) {
  var noCheck = [0, 901, 902, 903, 904, 905, 906];
  for (var i = 0; i < noCheck.length; ++i) {
    if (noCheck[i] === menu) return;
  }
  var authList = Object(__WEBPACK_IMPORTED_MODULE_6__store_utils_storage_js__["a" /* getLocalStore */])('AUTH_LIST');
  if (authList !== null && authList.indexOf(menu) < 0) {
    next({ path: '/top' });
  }
}

router.afterEach(function (to, from) {
  __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].commit('onLoading', false);
});
/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "dI8L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_mutation_types_js__ = __webpack_require__("AZxf");


// import api from '../../api/api.js'

var state = {
  shain_no: null,
  shain_name: null,
  org_id: null,
  post_id: null,
  job_id: null,
  start_hire_date: null,
  end_hire_date: null,
  start_retire_date: null,
  end_retire_date: null,
  serve_length_year: null,
  serve_length_month: null,
  serve_length_date: null,
  recruit_id: null
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__utils_mutation_types_js__["f" /* SEARCH_SHAIN_NO */], function (state, num) {
  state.shain_no = num;
});

var getters = {
  getShainNo: function getShainNo(state) {
    return state.shainNo;
  }
};

var actions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__utils_mutation_types_js__["f" /* SEARCH_SHAIN_NO */], function (_ref, num) {
  var commit = _ref.commit;

  commit(__WEBPACK_IMPORTED_MODULE_1__utils_mutation_types_js__["f" /* SEARCH_SHAIN_NO */], num);
});

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "laiv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setLocalStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getLocalStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return removeLocalStore; });
/* unused harmony export clearLocalStore */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setSessionStore; });
/* unused harmony export getSessionStore */
/* unused harmony export removeSessionStore */
/* unused harmony export clearSessionStore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/*
* ローカルストレージにセット
*/
var setLocalStore = function setLocalStore(name, content) {
  if (!name) return;
  if (typeof content !== 'string') {
    content = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(content);
  }
  localStorage.setItem(name, content);
};

/**
 * ローカルストレージから取得
 */
var getLocalStore = function getLocalStore(name) {
  if (!name) return;
  return localStorage.getItem(name);
};

/**
 * ローカルストレージから削除
 */
var removeLocalStore = function removeLocalStore(name) {
  if (!name) return;
  localStorage.removeItem(name);
};

/*
* ローカルストレージを全て削除
*/
var clearLocalStore = function clearLocalStore() {
  localStorage.clear();
};
/*
* セッションストレージにセット
*/
var setSessionStore = function setSessionStore(name, content) {
  if (!name) return;
  if (typeof content !== 'string') {
    content = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(content);
  }
  sessionStorage.setItem(name, content);
};

/**
 * ローカルストレージから取得
 */
var getSessionStore = function getSessionStore(name) {
  if (!name) return;
  return sessionStorage.getItem(name);
};

/**
 * ローカルストレージから削除
 */
var removeSessionStore = function removeSessionStore(name) {
  if (!name) return;
  sessionStorage.removeItem(name);
};

/*
* ローカルストレージを全て削除
*/
var clearSessionStore = function clearSessionStore() {
  sessionStorage.clear();
};

/***/ }),

/***/ "pyT+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_mutation_types_js__ = __webpack_require__("AZxf");



var state = {
  menu: ''
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__utils_mutation_types_js__["c" /* MENU */], function (state, _ref) {
  var num = _ref.num;

  state.menu = num;
});

var getters = {
  getMenu: function getMenu(state) {
    return state.menu;
  }
};

var actions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__utils_mutation_types_js__["c" /* MENU */], function (_ref2, num) {
  var commit = _ref2.commit;

  commit(__WEBPACK_IMPORTED_MODULE_1__utils_mutation_types_js__["c" /* MENU */], { num: num });
});

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "v1eo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getUser */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getSelectMember; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getShainInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SelectAll; });
/* unused harmony export SelectOneRecord */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getUserMaster; });
/* unused harmony export getPostSort */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getExportUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SelectUserModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AutoInputUserName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UserMasterShowSearch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_env_js__ = __webpack_require__("AMf1");


__WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.withCredentials = true;
var getUser = function getUser(shainNo) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__config_env_js__["a" /* apiUrl */] + '/user/selective', {
    shain_no: shainNo,
    option: ['ShainNo', 'ShainName', 'DeptId', 'DeptName', 'DivisionId', 'DivisionName', 'PostId', 'PostName', 'JobId', 'JobName', 'EmployStatusId', 'EmployStatusName', 'RecruitId', 'RecruitName', 'JoiningRouteId', 'JoiningRouteName', 'Birthday']
  });
};
var getSelectMember = function getSelectMember(AuthData, ShainNo, ShainName, DeptId, DivisionId, AreaId, GroupId, HireOnStart, HireOnEnd, PostId, PointOfTime, Retire, NoDivisionLimited) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__config_env_js__["a" /* apiUrl */] + '/user/selectMember', {
    'auth_data': AuthData,
    'shain_no': ShainNo,
    'shain_name': ShainName,
    'dept_id': DeptId.map(Number),
    'division_id': DivisionId.map(Number),
    'area_id': AreaId.map(Number),
    'group_id': GroupId.map(Number),
    'hire_on_start': HireOnStart,
    'hire_on_end': HireOnEnd,
    'post_id': PostId.map(Number),
    'point_of_time': PointOfTime,
    'retire': Retire,
    'no_division_limited': NoDivisionLimited
  });
};

var getShainInfo = function getShainInfo(ShainNo, Option) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__config_env_js__["a" /* apiUrl */] + '/user/selective', {
    'shain_no': ShainNo,
    'option': Option
  });
};

var SelectAll = function SelectAll(ShainNoNone, ShainNo, PlanId, ShainName, DeptId, DivisionId, AreaId, GroupId, PostId, LoginRights, ShainNoDigest) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__config_env_js__["a" /* apiUrl */] + '/user/get', {
    'shain_no_none': ShainNoNone,
    'shain_no': ShainNo,
    'plan_id': PlanId,
    'shain_name': ShainName,
    'dept_id': DeptId,
    'division_id': DivisionId,
    'area_id': AreaId,
    'group_id': GroupId,
    'post_id': PostId,
    'login_rights': LoginRights
  });
};

var SelectOneRecord = function SelectOneRecord(ShainNoDigest) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__config_env_js__["a" /* apiUrl */] + '/user/selective', {
    shain_no_digest: ShainNoDigest,
    option: ['ShainNo', 'PlanId', 'ShainName', 'DivisionName', 'PostName', 'PostSortOrder', 'OfficeName', 'RetireOn', 'Birthday']
  });
};

var getUserMaster = function getUserMaster(hash) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__config_env_js__["a" /* apiUrl */] + '/user/master/' + hash);
};

var getPostSort = function getPostSort(ShainNo, Data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__config_env_js__["a" /* apiUrl */] + '/user/selective', {
    shain_no: ShainNo,
    option: Data
  });
};

var getExportUser = function getExportUser(ShainNoNone, ShainNo, PlanId, ShainName, DeptId, DivisionId, AreaId, GroupId, PostId, LoginRights, LoginRightsList) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__config_env_js__["a" /* apiUrl */] + '/user/export', {
    'shain_no_none': ShainNoNone,
    'shain_no': ShainNo,
    'plan_id': PlanId,
    'shain_name': ShainName,
    'dept_id': DeptId,
    'division_id': DivisionId,
    'area_id': AreaId,
    'group_id': GroupId,
    'post_id': PostId,
    'login_rights': LoginRights,
    'login_rights_list': LoginRightsList
  });
};

var SelectUserModal = function SelectUserModal(authData, divisionConf, postConf, retireConf, shainName) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__config_env_js__["a" /* apiUrl */] + '/selectUser/modal', {
    auth_data: authData,
    division_conf: divisionConf,
    post_conf: postConf,
    retire_conf: retireConf,
    shain_name: shainName
  });
};

var AutoInputUserName = function AutoInputUserName(authData, divisionConf, postConf, retireConf, shainNo) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__config_env_js__["a" /* apiUrl */] + '/autoInputUserName', {
    auth_data: authData,
    division_conf: divisionConf,
    post_conf: postConf,
    retire_conf: retireConf,
    shain_no: shainNo
  });
};

var UserMasterShowSearch = function UserMasterShowSearch() {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__config_env_js__["a" /* apiUrl */] + '/user/master');
};

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.785addb167e75839ab71.js